import cEditLink from '#themes/default/default/components/editLink/editLink.js';
import cSkeleton from '#themes/default/default/components/skeleton/skeleton.js';

import template from './billingSummary.html' with { type: 'html' };

export default {
	name: 'CBillingSummary',
	components: {
		cEditLink,
		cSkeleton
	},
	props: {
		ariaDescribeId: {
			type: String,
			default: null
		},
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		isCompany: {
			type: Boolean,
			default: false
		},
		isShoppingCartPage: {
			type: Boolean,
			default: false
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		providerAccount: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		getLocalizedCountry() {
			const country = this.order.countryList.find((country) => country.value === this.customer.billing.country);
			return country ? country.label : this.customer.billing.countryName;
		}
	},
	template
};
